export const isKore = window.location.hostname.includes("kore.co.il");
